import React, { useState, useEffect } from "react";
import {
  Button,
  Center,
  Box,
  Grid,
  GridItem,
  HStack,
  VStack,
  Card,
  Heading,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { ColorModeSwitcher } from "../ColorModeSwitcher";
import { Nav } from "../containers/Nav";

function NotFound() {
  return (
    <Grid
      templateAreas={`"header header" "main main" "footer footer"`}
      gridTemplateRows={"50px 1fr 30px"}
      gridTemplateColumns={"150px 1fr"}
      h="200px"
      color="blackAlpha.700"
    >
      <Nav page={"404"} />

      <GridItem pl="2" area={"main"}>
        <Center>
          <Card
            mx="5"
            my="5"
            p="45px"
            minW="2xl"
            maxW="4xl"
            bg={useColorModeValue("gray.100", "gray.900")}
            align="top"
          >
            <VStack>
              <Box>
                <Heading fontSize="7xl">404</Heading>
              </Box>
              <Box>
                <Heading fontSize="4xl">Page not found</Heading>
              </Box>
              <Box mt="4">
                <Link to="/">
                  <Button colorScheme="teal">Go home</Button>
                </Link>
              </Box>
            </VStack>
          </Card>
        </Center>
      </GridItem>

      {/*
      <GridItem area={'footer'}>
        <Box
          p="30px"
          width="100%"
          bg={useColorModeValue('gray.600', 'gray.600')}
          color={useColorModeValue('gray.100', 'gray.100')}
        >
          <Center>
            <Text>Copyright © {new Date().getFullYear()} Hubit</Text>
          </Center>
        </Box>
      </GridItem>
      */}
    </Grid>
  );
}

export default NotFound;
